import { Spinner } from '@alfa-bank/site-spinner';
import type { FC } from 'react';
import React from 'react';
import { Grid } from '@alfa-bank/site-grid-universal';
import cn from 'classnames';
import { Aligner } from '@alfa-bank/site-aligner';

import type { TCheckData } from './models';

export const CheckData: FC<TCheckData> = ({ Text, styles, text }) => {
    return (
        <Grid
            alignment="center"
            className={cn(styles.checkData, styles.external)}
            collapse
            columnsMargin={0}
            dataTestId="dc-form-check-data"
            justify="center"
            vertical
        >
            <Aligner>
                <Text styler={{ margin: 0, padding: 0 }} view="primary-large">
                    {text}
                </Text>
                <Spinner styler={{ marginTop: 24 }} />
            </Aligner>
        </Grid>
    );
};
